import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from 'store/reducers';
import { MainFormState } from 'types/forms/form.def';
import { addClient as addClientAction } from 'store/actions';
import { copyDeliveryInformations as copyDeliveryInformationsAction } from 'store/actions/client.actions';
import { errorAndStateParams } from 'helpers/forms/errorAndStateParams';
import { FormInvoiceInformation } from 'components/molecules/Forms/FormInvoiceInformation';

const ClientFields = () => {
  const { client } = useSelector((state: AppState) => state);
  const dispatch = useDispatch();
  const addClient = (newParams: MainFormState<any>) =>
    dispatch(addClientAction(newParams));

  const handleChange = async e => {
    const value = e.target.value;
    const field = e.target.name;

    if (client.values.affilie || !client.values.livraisonhorslycee) {
      client.errors = {
        ...client.errors,
        mobilelivraison: false,
        nomlivraison: false,
        prenomlivraison: false
      };
    }

    const newParams = errorAndStateParams(field, value, client);
    addClient(newParams);
    if (client.sameDeliveryInformation) {
      dispatch(copyDeliveryInformationsAction());
    }
  };

  const handleChangeSwitch = (value, name) => {
    const e = {
      target: {
        value: value.toString(),
        name: name
      }
    };
    handleChange(e);
  };

  return (
    <>
      <FormInvoiceInformation
        handleChange={handleChange}
        handleChangeSwitch={handleChangeSwitch}
        client={client.values}
        errors={client.errors}
      />
    </>
  );
};
export default ClientFields;
